export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "喵趣漫画网主要收录哪些类型的作品？",
    a: "喵趣漫画网专注萌系日常题材，主要收录治愈番、搞笑萌漫、软萌画风、温馨向轻喜剧等轻松类作品。所有内容都以「点开就开心、不用费脑」为挑选标准，适合碎片时间放松观看。",
  },
  {
    q: "网站上的漫画需要付费吗？",
    a: "目前喵趣漫画网以作品推荐与内容分享为主，浏览分类、作品详情、热门榜单和编辑推荐等功能都可以免费使用。如后续开通付费阅读，我们会在每个作品页明确标注，不会在未经提示的情况下产生任何费用。",
  },
  {
    q: "如何快速找到我喜欢的那类漫画？",
    a: "你可以在顶部导航进入分类页面，在「治愈番」「搞笑萌漫」「软萌画风」「温馨向轻喜剧」四个频道间切换；也可以在首页的热门推荐、编辑精选和最近更新板块浏览，或使用站内搜索按标题快速定位作品。",
  },
  {
    q: "网站多久更新一次推荐内容？",
    a: "热门榜单和最近更新板块会随作品连载进度持续更新；编辑精选则由团队每周人工筛选，保证每一部上榜作品都符合治愈、轻松、好看的标准，避免你追更踩雷。",
  },
  {
    q: "追更时如何判断一部漫画是否已完结？",
    a: "每部作品卡片上都标注了「连载中」或「已完结」状态，进入详情页还能看到总章节数、最近更新话数与更新时间。对于更新频率较慢的作品，我们也会在介绍中加以说明。",
  },
  {
    q: "我可以投稿推荐自己喜欢的萌系漫画吗？",
    a: "当然可以。如果你有一部非常想分享给大家的萌系作品，欢迎通过页脚的联系邮箱投稿，附上作品名称、作者和一段 200 字以内的推荐理由。审核通过后，我们会在对应频道署名推荐。",
  },
];